import { Stack, styled } from '@mui/material';

export const DRAWER_WIDTH_LARGE = '35vw';
export const DRAWER_WIDTH_SMALL = '50vw';
export const DRAWER_WIDTH_MOBILE = '100%';

export const Content = styled(Stack)({
  justifyContent: 'space-between',
  flexDirection: 'row',
  height: '100%',
  width: '100%'
});

export const MeetingMedia = styled(Stack)({
  width: '100%',
  justifyContent: 'flex-start',
  borderRadius: '24px',
  height: '100%'
});

export const MediaStack = styled(Stack)({
  paddingBottom: '2vh',
  height: '50%',
  width: '100%',
  overflow: 'hidden',
  borderRadius: '16px'
});

export const TranscriptStack = styled(Stack)({
  height: '50%',
  width: '100%'
});
